export default {
      id: "graph-laurentides-usage",
      viewBox: "0 0 172 172",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-laurentides",
      toString: function () {
        return this.url;
      }
    }